import { OrganizationType } from '@dealstack/shared/lib/generated';
import { z } from 'zod';

export enum UPDATE_ORGANIZATION_FORM_FIELDS {
	NAME = 'organization_name',
	CONTACT_EMAIL = 'contact_email',
	TYPE = 'organization_type',
}

export const UpdateOrganizationShape = () =>
	z.object({
		[UPDATE_ORGANIZATION_FORM_FIELDS.NAME]: z.string().trim().min(1, 'Required'),
		[UPDATE_ORGANIZATION_FORM_FIELDS.CONTACT_EMAIL]: z
			.string()
			.email()
			.optional()
			.or(z.literal(''))
			.nullable(),
		[UPDATE_ORGANIZATION_FORM_FIELDS.TYPE]: z
			.nativeEnum(OrganizationType)
			.nullable()
			.or(z.literal('')),
	});

export type UpdateOrganizationFormValues = z.infer<ReturnType<typeof UpdateOrganizationShape>>;

export interface UpdateOrganizationSettingsInputsValues {
	[UPDATE_ORGANIZATION_FORM_FIELDS.NAME]: string;
	[UPDATE_ORGANIZATION_FORM_FIELDS.CONTACT_EMAIL]: string | undefined;
	[UPDATE_ORGANIZATION_FORM_FIELDS.TYPE]: OrganizationType | null | '';
}
